// src/pages/foundher/modules/foundher/FoundHerData.js

export const foundHerModules = [
  { icon: "🏠", label: "HerKart", action: "herKart", view: "HERKART" },
  { icon: "🛍️", label: "FindItLocal Classified", action: "localListing", view: "LOCALLIST" },
  { icon: "📢", label: "Public Posted Needs", action: "findNeeds", view: "FINDNEED" },
  { icon: "✍️", label: "Post Classified Local Needs", action: "postNeed", view: "NEED" },
  { icon: "💼", label: "Hustles", action: "hustles", view: "HUSTLES" },
  { icon: "💡", label: "Youth Innovations", action: "innovations", view: "INNOVATIONS" },
  { icon: "🏷️", label: "Youth Brands", action: "herBrands", view: "HERBRANDS" },
  { icon: "✨", label: "She in Spotlight", action: "spotlight", view: "SPOTLIGHT" },
  { icon: "💖", label: "Support Her Journey", action: "supportAFoundher", view: "SUPPORT" },
  { icon: "🏪", label: "Her Exhibitions", action: "nabora", view: "NABORA" },
  { icon: "🫶", label: "VocalForLocal", action: "vocalForLocal", view: "VOCALFORLOCAL" },
  { icon: "🏠", label: "OneView", action: "herOneView", view: "HERONEVIEW" },
];

export const currentCampaign = {
  title: "FoundHer 2026",
  theme: "Purpose • Build • Grow",
  emoji: "💜",
  founders: 1250,
  duration: "Year Round",
  description:
    "A global movement helping young women discover their purpose, launch ventures, build sustainable businesses, and inspire the next generation."
};

export const quickActions = [
  { icon: "👩", label: "Profile", action: "profile" },
  { icon: "💜", label: "Purpose", action: "purpose" },
  { icon: "💡", label: "Venture", action: "venture" },
  { icon: "🚀", label: "Journey", action: "journey" },
  { icon: "🔥", label: "Streaks", action: "streaks" },
  { icon: "🛍️", label: "Marketplace", action: "marketplace" },
  { icon: "📦", label: "Orders", action: "orders" },
  { icon: "💰", label: "Funding", action: "funding" },
  { icon: "🎁", label: "Support", action: "support" },
  { icon: "🎓", label: "Academy", action: "academy" },
  { icon: "🤝", label: "Mentors", action: "mentors" },
  { icon: "🌐", label: "Network", action: "network" },
  { icon: "⭐", label: "Trust", action: "trust" },
  { icon: "🏆", label: "Challenges", action: "challenges" },
  { icon: "🌟", label: "Spotlight", action: "spotlight" },
  { icon: "🎯", label: "Dreams", action: "dreams" },
  { icon: "🏫", label: "Communities", action: "communities" },
  { icon: "🧰", label: "Resources", action: "resources" },
  { icon: "🎛️", label: "Preferences", action: "preferences" },
  { icon: "🌟", label: "MSME Hub", action: "msme" },
  { icon: "🤝", label: "Her SHG", action: "hershg" },
  { icon: "👩", label: "Identity", action: "identity" },
  { icon: "🙋", label: "SheEarns", action: "sheearns" },  
  { icon: "⭐", label: "PostIt", action: "postToList" },
  { icon: "👯‍♀️", label: "PehchaanSetu", action: "pehchaanSetu" },
];

export const whyFoundHerPoints = [
  {
    emoji: "🌱",
    title: "Purpose First",
    desc: "Discover your 'Why' before building your business."
  },
  {
    emoji: "🚀",
    title: "Launch With Confidence",
    desc: "Transform ideas into ventures through guided entrepreneurship."
  },
  {
    emoji: "🤝",
    title: "Community Powered",
    desc: "Customers, mentors, volunteers, and supporters grow together."
  },
  {
    emoji: "💜",
    title: "Women First",
    desc: "A safe, inspiring ecosystem created for the next generation of women founders."
  }
];

export const testimonials = [
  {
    name: "Aarohi Mehta",
    role: "Student Founder",
    text: "FoundHer gave me the confidence to launch my first business. My first customer changed everything.",
    emoji: "🌸"
  },
  {
    name: "Nisha Kapoor",
    role: "Handmade Products Creator",
    text: "I found mentors, customers, and friends who genuinely wanted to see me succeed.",
    emoji: "🛍️"
  },
  {
    name: "Sara Khan",
    role: "Digital Creator",
    text: "It's more than a marketplace. It's a community that celebrates every milestone, no matter how small.",
    emoji: "🚀"
  }
];